"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromoBaselineOutput_1 = require("../model/PromoBaselineOutput");

var PromoBaselineOutputConverter_1 = require("./PromoBaselineOutputConverter");
/**
 * Implementation of {@link PromoBaselineOutputConverter}.
 *
 * @author ZSr
 */


var PromoBaselineOutputConverterImpl =
/*#__PURE__*/
function (_PromoBaselineOutputC) {
  _inherits(PromoBaselineOutputConverterImpl, _PromoBaselineOutputC);

  function PromoBaselineOutputConverterImpl() {
    _classCallCheck(this, PromoBaselineOutputConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoBaselineOutputConverterImpl).apply(this, arguments));
  }

  _createClass(PromoBaselineOutputConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromoBaselineOutput_1.PromoBaselineOutput(PromoBaselineOutput_1.PromoBaselineOutput.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PromoBaselineOutput_1.PromoBaselineOutput.schema.date.valueOf(conversions.toDate(source.date)), PromoBaselineOutput_1.PromoBaselineOutput.schema.amount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        date: conversions.fromDate(source.date),
        amount: source.amount
      });
      return result;
    }
  }]);

  return PromoBaselineOutputConverterImpl;
}(PromoBaselineOutputConverter_1.PromoBaselineOutputConverter);

exports.PromoBaselineOutputConverterImpl = PromoBaselineOutputConverterImpl;